import { Component } from '@angular/core';

@Component({
    selector: 'app-evaluaciones',
    templateUrl: './evaluaciones.component.html',
    styleUrls: ['./evaluaciones.component.scss'],
    standalone: false
})
export class EvaluacionesComponent {

  
}
